import Button from "components/Shared/Button/Button"
import { useEffect, useState } from "react"
import { useDropzone } from "react-dropzone"

type ExcelUploaderProps = {
  onSelect?: (file?: File) => void
  beforeSelect?: any
  placeholder?: string
  subPlaceholder?: string
  clearAll?: boolean
  accept?: { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"?: string[]; "text/csv"?: string[] }
  maxSizeBytes?: number
  onFileRejected?: (code: string) => void
}

export default function ExcelUploader({
  onSelect,
  placeholder,
  subPlaceholder,
  clearAll,
  beforeSelect,
  maxSizeBytes,
  onFileRejected,
  accept = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx", ".xls"],
    "text/csv": [".csv"],
  },
}: ExcelUploaderProps) {
  const [files, setFiles] = useState<File[]>([])

  const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
    accept,
    maxFiles: 1,
    maxSize: maxSizeBytes,
    noClick: true,
    onDropRejected: fileRejections => {
      const rejectedCode = fileRejections[0]?.errors?.[0]?.code ?? "file-rejected"
      onSelect?.(undefined)
      setFiles([])
      onFileRejected?.(rejectedCode)
    },
  })

  useEffect(() => {
    if (acceptedFiles.length) {
      onSelect?.(acceptedFiles[0])
      setFiles([...acceptedFiles])
    } else {
      onSelect?.(undefined)
    }
  }, [acceptedFiles])

  useEffect(() => {
    if (clearAll) setFiles([])
  }, [clearAll])

  return (
    <div className="mt-6 h-32 border border-black border-dashed flex justify-center items-center">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <div className="flex justify-center flex-col items-center">
          {files.length > 0 ? (
            <>
              <p>Selected file:</p>
              <p className="mt-1">{files[0].name}</p>
            </>
          ) : (
            <>
              <div className="mb-6 text-center">
                <p>{placeholder || "Drop the Excel file here or click to browse your PC"}</p>
                <p>{subPlaceholder || ""}</p>
              </div>
              <Button
                action={() => {
                  if (!beforeSelect) {
                    open()
                    return
                  }
                  if (beforeSelect()) open()
                }}
                label="Browse"
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
